import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import { color } from '../../templates/Ui';
const StyledTableRow = styled(TableRow) `
    border-top: 1px solid #ececec;

    @media only screen and (min-width: 992px) {
        padding: 15px;
    }
`;
const StyledTableCell = styled(TableCell) `
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .table-cell__label {
        padding-right: 10px;
        flex-shrink: 0;
    }

    .table-cell__label,
    .table-cell__value {
        color: ${color.paragraph.base};
        font-weight: 400;
        font-size: 16px;
    }
`;
const ClaimTableRow = ({ label, value, noHover, className, }) => {
    return (_jsxs(StyledTableRow, { className: className, noHover: noHover, children: [_jsx(StyledTableCell, { value: label }), _jsx(StyledTableCell, { value: value })] }));
};
export default ClaimTableRow;
